export const environment = {
  apiUrl: 'https://app-api.ilwu.org',
  production: true,
};
